module.exports = __webpack_public_path__ + "img/sustain-development.12920574.png";